module.exports = __webpack_public_path__ + "cbe415af44ec4e3dacdbcc7b4ee029b0.jpg";


//////////////////
// WEBPACK FOOTER
// ../images/speakers/abhinav-rastogi.jpg
// module id = 430
// module chunks = 0